import { useDrawerToggle } from '@csp/csp-web-hooks';
import { FC } from 'react';
import { TemporaryDrawer } from '../../../common/component/TemporaryDrawer';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { HelpIconButton } from '../../navigation/component/HeaderNavToolsIcons';
import { TechnicalSupportContainer } from './TechnicalSupportContainer';

export const TechnicalSupportDrawerContainer: FC = () => {
  const drawerToggle = useDrawerToggle();
  const supportContent = StaticContentService.getGenericBlock('webHcpTechnicalSupport', 'support');

  return (
    <>
      <TemporaryDrawer
        header={supportContent.header.drawer.text}
        open={drawerToggle.isOpen}
        onClose={drawerToggle.closeAsync}
        id="support-drawer"
      >
        <TechnicalSupportContainer />
      </TemporaryDrawer>

      <HelpIconButton onClick={drawerToggle.open} data-testid="support-drawer-button" />
    </>
  );
};
